import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Observable, Subscription, map, startWith } from 'rxjs';
import {NotificationSettingsService}  from 'src/app/services/notification-settings.service'
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { MatChipInputEvent } from '@angular/material/chips';
import {StaticdataService}  from 'src/app/services/staticdata.service'
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';
import { ColorsService } from 'src/app/services/colors.service';
import { DialogService } from 'src/app/util/dialog/dialog.service';
import * as mammoth from 'mammoth';

@Component({
  selector: 'app-notification-settings',
  templateUrl: './notification-settings.component.html',
  styleUrls: ['./notification-settings.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class NotificationSettingsComponent {
  separatorKeysCodes: number[] = [ENTER, COMMA];
  messageTypeCtrl = new FormControl('');
  selectedStateTypes: string[] = [];
  allStateTypes: string[] = [];
  @ViewChild('messageTypeInput') messageTypeInput!: ElementRef<HTMLInputElement>;
  announcer = inject(LiveAnnouncer);

  passThrough:any
  search:any={searchText:""}
  pagestr:any={
    number:'0',
    size:'10'
  }
 
 
  action:any
  groupList:any
  settingJson:any
  totalElements:any=0
  menu:any="20px";
  showGroup:boolean=false;
  showGroupPopup:boolean=false
  columnsGroupDisplay: string[] = ['name','creationDate','delete'];
 
  queueRegFg! : FormGroup
  dataSource:any = [];
  groupData:any = [];
  expandedElement!: any | null;
  color:any
constructor(private StaticdataService:StaticdataService,private PaymentConfigService:PaymentConfigService,private SettingsService:SettingsService,private router:Router,private location:Location,private fb : FormBuilder,    private toastMsgService : ToastmsgService,
  private AirManagementService:NotificationSettingsService,private userPrivileges: UserPrivilegeService,private ColorsService:ColorsService,private DialogService:DialogService
  ){



    this.userPrivileges.userPrivilegesByModule('business-group').then((privileges:any) => {
      this.privilegesValue(privileges)
    })
    .catch((error:any) => {
    console.error(error); // Handle errors, if any
    });

    this.ColorsService.colors("","").then((color:any) => {
      this.color=color
     })
     .catch((error:any) => {
     });

   
  this.SettingsService.airManageJson().then((data:any) => {
    this.settingJson=data["menu"]
    this.showGroup=true
   })
   .catch((error:any) => {
   });

   this.dataFields();
   this.getQueuelist({page: this.pagestr.number, size: this.pagestr.size,})
  

}
privilegesView:any
  privilegesValue(privs:any){
   
    let privileges="";
  
  if(privs.includes('view')){
    this.privilegesView="VAMD"
  }else{
    this.privilegesView="AccessDenied"
  }
  
  }

dataFields(){
  this.queueRegFg=this.fb.group({
    "name" : ['',[Validators.required]],
    "source" : ['',[Validators.required]],
    // "priority" : ['',[Validators.required]],
    "status":['A',[Validators.required]],
  });
  
  
}

OnClickLink(subMenu:any){
  if(subMenu==="Amadeus"){
  this.router.navigate(["/app/Air-Management/Amadeus"]);}
  else if(subMenu==="User"){
    this.router.navigate(["/app/Air-Management/User-config"]);

  }

}


  backClick(){
window.location.href="/app/settings"
  }


 
 
 
  onClickGroup(){
   
    this.showGroup=true;
  
  }
 
 
 
  onAddGroup(){
    this.action='newQue'
    this.htmlContent =''

    this.showGroupPopup=true

  }
  
  closePopup() {
   

    this.showGroupPopup=false
    this.dataFields()
  }
 

  AddQueue() {
    this.AirManagementService.saveQueue(this.queueRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Notification Added Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.dataFields();
           this.showGroupPopup=false
           this.getQueuelist({page: this.pagestr.number, size: this.pagestr.size,})

          } else {
            const body : any = res.body;
            this.registerGroupErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {

          this.registerGroupErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerGroupErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Notification",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to save Notification",msgTitle:  "Warning", msgType : "W"});
    } 
  }

  searchUser(){
  
    this.getQueuelist({page: this.pagestr.number, size: this.pagestr.size,})
  }

  nextPage(event:PageEvent) {
    
    let page:any = {};
    page['page'] = event.pageIndex.toString();
    page['size'] = event.pageSize.toString();
    this.getQueuelist(page)
    //this.getAllUser(page)
  
  }
  getQueuelist(page:any){

    this.AirManagementService
    .getQueueList(page,this.search)
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
          if(data.result.content.length>0){
            this.pagestr.number=data.result['number']
            this.pagestr.size=data.result['size']
          }

         console.log(res)
          this.groupData=data.result.content;
          this.totalElements = data.result['totalElements'];
         if(this.groupData.length>0){
         }else{
          

         }
        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }

 

  formatDate(val: Date) {
    let convertedValue:any = ""
    if(val){
    let datepipe = new DatePipe("en");
    //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
    convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
    }
    return convertedValue;
  }

 





 
  
 

 



  



  

  rowGroupClick(item:any){
    this.htmlContent =''
    this.action='updateQue'

    this.showGroupPopup=true;

    this.queueRegFg=this.fb.group({
      "name" : [item.name,[Validators.required]],
      // "priority" : [Number(item.priority),[Validators.required]],
      "source" : [item.source,[Validators.required]],
      "uuid" : [item.uuid],
      "status":[item.status,[Validators.required]],
    });
    this.readFile(item.source)
  }
  



  onlyNumberKey(event:any) {
     
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;
    return true;
  }

  onlyNumberSpecialKey(event: any): boolean {
    let charCode = (event.which) ? event.which : event.keyCode;

    // Allow numbers (48-57), plus sign (+ which is 43), minus sign (- which is 45), and colon (: which is 58)
    if (
        (charCode >= 48 && charCode <= 57) ||  // Allow numbers
        charCode === 43 ||  // Allow plus sign (+)
        charCode === 45 ||  // Allow minus sign (-)
        charCode === 58     // Allow colon (:)
    ) {
        return true;
    }

    // Prevent default for other characters
    return false;
}
  disable=false

  numbers: number[] = Array.from({ length: 25 }, (_, i) => i + 1);

  sourceCodeList:any=[]


  sourceCodeToName(data:any){
   return  this.sourceCodeList.filter((item:any)=>item.code===data)[0].name
  }




  deleteQueue(item:any) {


    this.DialogService.open({msg : "Are you sure you want to delete this Notification?",title : "Confirmation",buttonType : "YesNo"})
     
    this.DialogService.onResponse((response :  string) => {
     
      if(response=="Yes") {
      
    this.AirManagementService.deleteQueue(item)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Notification Deleted Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.dataFields();
           this.showGroupPopup=false
           this.getQueuelist({page: this.pagestr.number, size: this.pagestr.size,})

          } else {
            const body : any = res.body;
            this.toastMsgService.setMsg({msg : "Failed to Delete Notification",msgTitle : "Warning", msgType : "W"});

          } 

        },error : (err) => {
          this.toastMsgService.setMsg({msg : "Failed to Delete Notification",msgTitle : "Warning", msgType : "W"});

        }
      }
    )
  }})
  }
  htmlContent:any
  onFileSelecteds(event: Event): void {
    const input = event.target as HTMLInputElement;
  
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();
  
      reader.onload = (e: any) => {
        const base64String = e.target.result as string; // This includes the data URI prefix
  
        // Set the Base64 string (or just the content after comma if needed)
        this.queueRegFg = this.fb.group({
          name: [this.queueRegFg.value.name, [Validators.required]],
          source: [base64String, [Validators.required]], // save base64 here
          status: [this.queueRegFg.value.status, [Validators.required]],
        });
  
        // Optional: use mammoth to extract HTML content
        const arrayBuffer = this.base64ToArrayBuffer(base64String.split(',')[1]);
        mammoth.convertToHtml({ arrayBuffer })
          .then(result => {
            this.htmlContent = result.value;
          })
          .catch(err => {
            console.error('Error converting .docx:', err);
          });
      };
  
      reader.readAsDataURL(file); // Converts to Base64
    }
  }
  
  base64ToArrayBuffer(base64: string): ArrayBuffer {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }
  readFile(input:any) {

    const arrayBuffer = this.base64ToArrayBuffer(input.split(',')[1]);
    mammoth.convertToHtml({ arrayBuffer })
      .then(result => {
        this.htmlContent = result.value;
      })
      .catch(err => {
        console.error('Error converting .docx:', err);
      });
  }

}
